angular.module("acl.visualizer.multiSelect", [
  "acl.common.filters",
  "acl.common.localize",
  "acl.visualizer.dataModel",
  "acl.visualizer.style",
  "templates-visualizer",
  "acl.core.conditionalCriteriaSelector",
]);
